module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWN4/ujbfwAJMgO/so9dkgAAAABJRU5ErkJggg=="